import { useState, Dispatch, SetStateAction } from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function useDisplayArticles(): {
  showArticles: boolean;
  showSections: boolean;
  setShowArticles: Dispatch<SetStateAction<boolean>>;
  isMobile: boolean;
} {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [showArticles, setShowArticles] = useState<boolean>(true);

  return {
    showArticles: isMobile ? showArticles : true,
    showSections: isMobile ? !showArticles : true,
    setShowArticles,
    isMobile,
  };
}
